import React, { Component } from 'react';
import { FlexColumn } from 'core/components/Flex';
import Card from 'core/components/Card';
import Icon from 'core/components/Icon';
import { inject, observer } from 'mobx-react';
import { FiEdit } from 'react-icons/fi';
import { Box, Text, Flex, Button } from 'core/components';
import { RemoveButton } from 'core/form';
import { formatDateTime, DEFAULT_DATETIME_FORMAT_WITH_SECONDS } from 'core/util/dateUtils';
import AddEditComment from './AddEditComment';

@inject('$auth')
@observer
export default class Comment extends Component {
  state = {
    editMode: false
  };

  get modelValues() {
    const { model } = this.props;

    return model.get();
  }

  get canEdit() {
    const { model, $auth } = this.props;
    const modelUserId = model.get('userId');

    return $auth.activeUser.id === modelUserId;
  }

  handleUpdate = () => {
    this.setState({
      editMode: false
    });
  };

  handleEditClick = () => {
    this.setState({
      editMode: true
    });
  };

  handleCancelClick = () => {
    this.setState({
      editMode: false
    });
  };

  renderControls = () => {
    const { model, inline } = this.props;

    if (!this.canEdit) {
      return null;
    }

    return (
      <Flex alignItems="center" gap="2px">
        <Button
          key="edit"
          icon={inline ? null : FiEdit}
          text={inline ? 'Edit' : null}
          title="Edit"
          minimal
          small
          onClick={this.handleEditClick}
        />
        <RemoveButton
          key="remove"
          model={model}
          text="Remove"
          entityName="comment"
          showIcon={!inline}
          hideText={!inline}
          small
        />
      </Flex>
    );
  };

  render() {
    const { editMode } = this.state;
    const { model, entityType, inline = false, large = true } = this.props;
    const { comment, user, cdate } = model.get();
    const { canEdit } = this;

    return (
      <FlexColumn gap={1} width="100%">
        {!editMode && !inline && (
          <Card pl={1}>
            <Flex justifyContent="space-between" gap={1} borderBottom="thinDotted">
              <Flex alignItems="center" lineHeight="20px" gap="4px">
                {entityType === 'alertAck' && (
                  <>
                    <Icon icon="endorsed" color="textColor" iconSize="12px" />
                    <Text fontWeight="500" small>
                      Acked
                    </Text>
                    <Text muted small>
                      by
                    </Text>
                  </>
                )}
                {entityType === 'alertAutoAck' && (
                  <>
                    <Icon icon="endorsed" color="textColor" iconSize="12px" />
                    <Text fontWeight="500" small>
                      Auto-acked
                    </Text>
                    <Text muted small>
                      by
                    </Text>
                  </>
                )}
                <Text small fontWeight="500" whiteSpace="nowrap" flex="1" textOverflow="ellipsis" overflow="hidden">
                  {user.user_full_name}
                </Text>
                <Text muted small whiteSpace="nowrap">
                  {formatDateTime(cdate, DEFAULT_DATETIME_FORMAT_WITH_SECONDS)}
                </Text>
              </Flex>
              {this.renderControls()}
            </Flex>
            <Flex p={1} pl={0}>
              <Text>{comment}</Text>
            </Flex>
          </Card>
        )}
        {!editMode && inline && (
          <Box>
            <Text as="div">{comment}</Text>
            {canEdit && (
              <Flex borderTop="thin" mt={1} pt="4px" justifyContent="flex-end">
                {this.renderControls()}
              </Flex>
            )}
          </Box>
        )}
        {editMode && (
          <AddEditComment
            entityType={entityType}
            commentModel={model}
            initialValue={this.modelValues.comment}
            onCancel={this.handleCancelClick}
            onComment={this.handleUpdate}
            editMode
            large={large}
          />
        )}
      </FlexColumn>
    );
  }
}
